<app-layout class="container--md">
    <div>
        <div class="unauthorized__content-container">
            <div class="unauthorized__left">
                <img src="/assets/images/Restricted Permission.svg" alt="unauthorized person">
            </div>
            <div class="unauthorized__right">
                <h1>Page not found</h1>
                <p>The page you are looking for is not found and may be due to the following reasons:</p>
                <br/>
                <ol>
                    <li>A requesting officer has recalled a document you were supposed to initially review.</li>
                    <li>A covering officer has completed the action on your behalf.</li>
                </ol>
                <p>Alternatively, you may try refreshing the worklist or <a href="mailto:{{pmmEmail}}">contact the PMM Helpdesk</a> for help.</p>
            </div>
        </div>
    </div>
</app-layout>